import { useState, useEffect, useCallback } from 'react'
import { HAS_COOKIESOLUTION } from '../utils/constants'

declare global {
  interface Window {
    cicl: string[]
    CookieConsent: {
      renew: () => void
    }
    CookieInformation: {
      loadConsent: () => void
      getConsentGivenFor: (cookieCategory: string) => boolean
      submitAllCategories: () => void
    }
  }
}

export interface UseConsentState {
  cookie_cat_functional: boolean
  cookie_cat_statistic: boolean
  cookie_cat_marketing: boolean
  [key: string]: boolean
}

const initialState = {
  cookie_cat_functional: false,
  cookie_cat_statistic: false,
  cookie_cat_marketing: false,
}

export const useConsent = () => {
  const [consentState, setConsentState] = useState<UseConsentState>(initialState)

  const handleSettingConsent = useCallback(() => {
    window?.cicl?.forEach((category: string) => {
      const consentGiven = window?.CookieInformation?.getConsentGivenFor(category)
      setConsentState(state => {
        if (state[category] !== consentGiven) {
          return {
            ...state,
            [category]: consentGiven,
            cookieFetched: true, //set to true once the window consent is fetched
          }
        }
        return state
      })
    })
  }, [])

  useEffect(() => {
    if (!HAS_COOKIESOLUTION) return
    window.addEventListener('CookieInformationConsentGiven', handleSettingConsent)

    return () => window.removeEventListener('CookieInformationConsentGiven', handleSettingConsent)
  }, [handleSettingConsent, consentState])

  useEffect(() => {
    if (!HAS_COOKIESOLUTION) return
    window?.CookieInformation?.loadConsent()
  }, [])

  return consentState
}
